import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationEnd, RoutesRecognized } from '@angular/router';

import { JhiLanguageHelper, StateStorageService } from '../../shared';
import {EventManagerService} from '../../shared/services/event-manager.service';
import { VERSION, VERSIONDATE, API_SERVER, API_SERVER_VERSION, DEBUG_INFO_ENABLED } from '../../app.constants';
import { MaintenanceService } from '../../shared/services/maintenance.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html'
})
export class MainComponent implements OnInit {
    subscriber: any;

    sidebarClosed = false;

  constructor(
        private jhiLanguageHelper: JhiLanguageHelper,
        public router: Router,
        private $storageService: StateStorageService,
        private eventManager: EventManagerService,
        private maintenanceService: MaintenanceService
    ) {
    if (DEBUG_INFO_ENABLED) {
      console.log('__ MARKTGILDE - BACKOFFICE - v' + VERSION + ' (' + VERSIONDATE + ')');
      console.log(` powered by
────────────────────────────────────────────────────────────────────────────────────
          ######
          ######
    ############  ###### #######    ###########    ######    ########
 ###############  ######  ######   ###### ######  #######  ############
################  ######   ###### ######   #####  ###### #######  #######
#####     ######  ######   ###### #####    ###### #####  ################
#####     ######  ######    ###########     ##########   ################
################  ######     #########       ########    #######   ##
 ###############  ######      #######        ########      ###########     #####
    ############  ######      ######          ######         #########     #####
────────────────────────────────────────────────────────────────────────────────────
`);
      console.log('__ DEBUG_INFO_ENABLED:', DEBUG_INFO_ENABLED);
      console.log('__ API_SERVER: ', API_SERVER);
      console.log('__ API_SERVER_VERSION: ', API_SERVER_VERSION);
    }
  }

    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
        let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'marketmanagerApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    }

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.jhiLanguageHelper.updateTitle(this.getPageTitle(this.router.routerState.snapshot.root));
            }
        });

      this.subscriber = this.eventManager.subscribe('toggleSidebar', (message) => {
        this.sidebarClosed = !this.sidebarClosed;
        // console.log('Sidebar: ' + this.sidebarClosed);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/layouts/main/main.component.ts